import moment from 'moment';
import _ from 'underscore.string';
import { messages as txTypeTranslations } from '../constants/labelMessages';

export const isNumber = value => !Number.isNaN(parseFloat(value));

export const shortenHash = address => {
  if (address === undefined) return '';
  const prefix = address.substring(0, 6);
  const suffix = address.substring(address.length - 4, address.length);
  return `${prefix}...${suffix}`;
};

export const dateFormatter = date => moment.utc(date).format('YYYY-MM-DD HH:mm:ss z');

export const amountFormatter = amount =>
  Number(amount)
    .toFixed(2)
    .toString();

export const ageFormatter = date => {
  const age = Math.ceil(moment.utc().diff(moment.utc(date), 'days'));
  return `${age} day(s)`;
};

export const convertNumberToString = (num, scale = 2) => {
  if (!isNumber(num)) return '0';

  // comment by Oleks <oleksandr@oneledger.io>
  // main idea here is to address a problem of
  // long number precission for cases like x.23849487579
  // basically it is smth like I have in my gist
  // https://gist.github.com/okovalov/11af907e7267faa62452cdaf50e5e26d
  if (!`${num}`.includes('e')) {
    return (+`${Math.round(`${num}e+${scale}`)}e-${scale}`).toString();
  }

  const arr = `${num}`.split('e');
  let sig = '';
  if (+arr[1] + scale > 0) {
    sig = '+';
  }
  const i = `${+arr[0]}e${sig}${+arr[1] + scale}`;
  const j = Math.round(i);
  const k = (+`${j}e-${scale}`).toString();

  return k;
};

// Format a given tx type to the human friendly label
// @depricated
export const mapTxType = (transaction) => {
  if (!transaction) return '';
  if (Object.entries(transaction).length === 0) return '';

  const { type } = transaction;
  if (!type) return '';

  const givenTxType = type.toLowerCase();

  const translatedTxType = txTypeTranslations[givenTxType] || _.titleize(givenTxType);

  return translatedTxType;
};

// Format a given tx type to the human friendly label - new transacation sturcture
// @todo add unit test and merge w mapTxType
export const mapTxTypeV2 = (transaction) => {
  if (!transaction) return '';
  if (Object.entries(transaction).length === 0) return '';

  const { txType } = transaction;
  if (!txType) return '';

  const givenTxType = txType.toLowerCase();

  const translatedTxType = txTypeTranslations[givenTxType] || _.titleize(givenTxType);

  return translatedTxType;
};
